import React from 'react';
import { useDispatch } from 'react-redux';

import { getMe } from '@portal/actions/auth';
import { redirectPortalMarketing } from '@portal/actions/marketing';

import { Box, CardBroadcast, CardProduct, Flex, IcPortalMarketing } from '@portal/components';

import { Constants } from '@portal/config/env';
import { arrayEducatorProfiles, brandsPortalMarketing } from '@portal/enum';
import { useGetMyDynamicButtons, useReduxState } from '@portal/hooks';
import { translate } from '@portal/services';
import { RenderCondition, formatProductList } from '@portal/utils';

import './ProductList.less';

const ProductList = () => {
  const dispatch = useDispatch();

  const {
    auth: { me: user },
    user: { products: allProducts },
    journey: { list: journeyList },
    config: { configPortal },
    brand: { brandConfig },
  } = useReduxState();

  const { data: dynamicButtons } = useGetMyDynamicButtons();

  const productList = user?.defaultProfileType
    ? formatProductList({
        profileType: user?.defaultProfileType,
        journeyList: journeyList ?? [],
        contentLibraryList: allProducts?.contentLibraries ?? [],
        lmsList: allProducts?.brandProducts,
        pijList: allProducts?.pijs ?? [],
      })
    : [];

  const hasPortalMarketing =
    brandsPortalMarketing?.includes(Constants?.brandDomain as string) &&
    !!user?.profileType &&
    arrayEducatorProfiles.includes(user?.profileType);

  const hasProducts =
    !!allProducts?.brandProducts?.length ||
    !!allProducts?.pijs?.length ||
    !!allProducts?.contentLibraries?.length ||
    !!journeyList?.length ||
    !!configPortal?.showBroadcast ||
    !!hasPortalMarketing ||
    !!dynamicButtons?.length;

  return (
    <Flex className="product-list">
      <RenderCondition condition={hasProducts}>
        {productList.map((product) => (
          <CardProduct
            key={product?.id}
            logoUrl={product.logoUrl}
            title={product.title}
            onClick={() => (window.location.href = product.url || '')}
          />
        ))}

        <RenderCondition condition={configPortal?.showBroadcast}>
          <CardBroadcast />
        </RenderCondition>

        <RenderCondition condition={hasPortalMarketing}>
          <Box>
            <CardProduct
              title={translate('COMPONENTS.PRODUCT_LIST.MARKETING')}
              icon={IcPortalMarketing}
              onClick={() => {
                if (!!user && !!user?.school && !!brandConfig) {
                  dispatch(redirectPortalMarketing(user, user?.school, brandConfig, () => dispatch(getMe())));
                }
              }}
            />
          </Box>
        </RenderCondition>

        <RenderCondition condition={!!dynamicButtons?.length}>
          {dynamicButtons?.map((button) => (
            <CardProduct
              key={button?.id}
              title={button.title}
              logoUrl={button.iconUrl}
              onClick={() => (window.location.href = button.redirectUrl || '')}
            />
          ))}
        </RenderCondition>
      </RenderCondition>

      <RenderCondition condition={!hasProducts}>
        <Box>
          <span>{translate('COMPONENTS.PRODUCT_LIST.EMPTY')}</span>
        </Box>
      </RenderCondition>
    </Flex>
  );
};

export default ProductList;
